<app-navbar />

<div class="container-fluid">
  <!-- Filtros -->
  <div class="card shadow-sm filtros-modernas border-0 mb-4">
    <div class="card-header d-flex align-items-center rounded-top">
      <i class="fas fa-search fs-5 me-2 text-white"></i>
      <h2 class="fw-bold">Cadastro</h2>
    </div>
    <div class="card-body">

      <div class="row mt-3" *ngIf="!erro">
        <div class="top-controls compact-controls d-flex flex-wrap align-items-center justify-content-between">
          <!-- Botão Filtrar -->
          <button class="btn btn-info btn-sm me-2" type="button" (click)="toggleFiltros()">
            <i class="fas fa-filter me-1"></i> Filtrar
          </button> <!-- Período -->
          <div class="d-flex align-items-center gap-2 me-3">
            <input class="form-control form-control-sm period-input" type="date" [(ngModel)]="filtroDataInicio" (change)="onFiltroDataInicioChange()" />
            <span>até</span>
            <input class="form-control form-control-sm period-input" type="date" [(ngModel)]="filtroDataFim"
              (change)="onFiltroDataFimChange()" />
            <button class="btn btn-primary ms-2" (click)="aplicarFiltro()">
              <i class="fas fa-sync-alt me-1"></i> Recarregar
            </button>
          </div>

          <!-- Itens por página + Paginação -->
          <div class="d-flex align-items-center gap-2 ms-auto">
            <label class="mb-0 small">Itens:</label>
            <select id="tamanhoPaginaSelect" class="form-select form-select-sm" [(ngModel)]="tamanhoPagina"
              (ngModelChange)="alterarTamanhoPagina($event)">
              <option [value]="5">5</option>
              <option [value]="10">10</option>
              <option [value]="25">25</option>
              <option [value]="50">50</option>
              <option [value]="100">100</option>
            </select>

            <span class="page-info small">
              Página {{paginaAtual}} de {{totalPaginas}} ({{totalItens}} itens)
            </span>

            <!-- Botões -->
            <button class="btn btn-outline-secondary btn-sm" (click)="paginaAnterior()" [disabled]="paginaAtual <= 1">
              <i class="fas fa-chevron-left"></i>
            </button>
            <button class="btn btn-outline-secondary btn-sm" (click)="proximaPagina()"
              [disabled]="paginaAtual >= totalPaginas">
              <i class="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>

      </div>

      <div class="row mt-2" *ngIf="showFiltros">
        <!-- <div class="col-md-3">
          <label class="form-label">Status</label>
          <select class="form-select" [(ngModel)]="filtroStatus">
            <option value="">Todos</option>
            <option value="EmAndamento">EmAndamento</option>
            <option value="Concluida">Concluido</option>
            <option value="Retornar">Retornar</option>
            <option value="Negada">Negado</option>
            <option value="Validado">Validado</option>
            <option value="Invalido">Invalido</option>
          </select>
        </div> -->
        <!-- <div class="col-md-3">
          <label class="form-label">Matrícula</label>
          <input type="text" class="form-control" [(ngModel)]="filtroMatricula" placeholder="Matrícula do consumidor" />
        </div> -->
        <div class="col-md-3">
          <label class="form-label">Nº Vistoria</label>
          <input type="text" class="form-control" [(ngModel)]="filtroNumeroVistoria" placeholder="Nº Vistoria" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Nome Consumidor</label>
          <input type="text" class="form-control" [(ngModel)]="filtroNomeConsumidor" placeholder="Nome do consumidor" />
        </div>
        <div class="col-md-3">
          <label class="form-label">CPF</label>
          <input type="text" class="form-control" [(ngModel)]="filtroCpf" placeholder="CPF" />
        </div>
        <div class="col-md-3">
          <label class="form-label">CNPJ</label>
          <input type="text" class="form-control" [(ngModel)]="filtroCnpj" placeholder="CNPJ" />
        </div>
        <div class="col-md-3">
          <label class="form-label">CEP</label>
          <input type="text" class="form-control" [(ngModel)]="filtroCep" placeholder="CEP" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Número</label>
          <input type="text" class="form-control" [(ngModel)]="filtroNumero" placeholder="Número (logradouro)" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Logradouro</label>
          <input type="text" class="form-control" [(ngModel)]="filtroLogradouro" placeholder="Logradouro" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Bairro</label>
          <input type="text" class="form-control" [(ngModel)]="filtroBairro" placeholder="Bairro" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Cidade</label>
          <input type="text" class="form-control" [(ngModel)]="filtroCidade" placeholder="Cidade" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Estado</label>
          <input type="text" class="form-control" [(ngModel)]="filtroEstado" placeholder="Estado" />
        </div>
        <div class="col-12 mt-2 d-flex gap-2">
          <button class="btn btn-primary" (click)="aplicarFiltro()">Aplicar filtros</button>
          <button class="btn btn-secondary" (click)="resetarERecarregar()">Limpar e Recarregar</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Estados -->
  <div *ngIf="carregando" class="alert alert-info d-flex align-items-center gap-2">
    <i class="bi bi-hourglass-split"></i> Carregando registros...
  </div>
  <div *ngIf="erro" class="alert alert-danger d-flex align-items-center gap-2">
    <i class="bi bi-exclamation-triangle-fill"></i> {{ erro }}
  </div>
  <div
    *ngIf="!carregando && servicosFiltrados.length === 0 && (filtroUsuarioId || (!filtroUsuarioId && servicos.length === 0))"
    class="alert alert-warning d-flex align-items-center gap-2">
    <i class="bi bi-folder-x"></i>
    <span *ngIf="filtroUsuarioId">Nenhum cadastro encontrado no período.</span>
    <span *ngIf="!filtroUsuarioId">Nenhum cadastro encontrado.</span>
  </div>

  <!-- Tabela de cadastros -->
  <div class="table-responsive" *ngIf="servicosFiltrados.length > 0">
    <table class="table table-bordered table-hover align-middle">
      <thead class="table-light">
        <tr>
          <th>Data</th>
          <th>Nome Consumidor</th>
          <th>CPF/CNPJ</th>
          <th>Telefone</th>
          <th>Endereço</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let cadastro of servicosFiltrados">
          <td>
            <span class="text-primary fw-bold">
              {{ cadastro.dataCadastro | date: 'dd/MM/yyyy' }}
            </span>
          </td>
          <td>
            <span class="fw-bold text-dark">
              <i class="bi bi-person-circle me-1 text-info"></i>
              {{ cadastro.nomeConsumidor }}
            </span>
          </td>
          <td>
            <span class="badge bg-light text-dark badge-campo-doc d-flex align-items-center gap-1">
              <i class="bi bi-credit-card-2-front text-secondary"></i>
              <ng-container *ngIf="cadastro.tipoUtilizacao === 'DOMICILIAR'; else cnpjCell">
                {{ maskCpf(cadastro.cpf) }}
              </ng-container>
              <ng-template #cnpjCell>
                {{ maskCnpj(cadastro.cnpj) }}
              </ng-template>
            </span>
          </td>
          <td>
            <span class="badge bg-light text-dark badge-campo-tel d-flex align-items-center gap-1"
              style="font-size:1.15rem;">
              <i class="bi bi-telephone text-success"></i>
              {{ maskTelefone(cadastro.telefone) }}
            </span>
          </td>
          <td>
            <span *ngIf="cadastro.endereco" class="text-secondary" style="font-size:0.97rem;">
              <i class="bi bi-geo-alt-fill text-primary"></i>
              <strong>{{ cadastro.endereco.logradouro }}</strong>, {{ cadastro.endereco.numero }}<br>
              {{ cadastro.endereco.bairro }} - {{ cadastro.endereco.cidade }}/{{ cadastro.endereco.estado }}
            </span>
            <span *ngIf="!cadastro.endereco" class="text-muted">-</span>
          </td>
          <td>
            <button class="btn btn-outline-primary btn-xs px-2 py-1" style="font-size:0.95rem;"
              (click)="verDetalhes(cadastro)" title="Ver detalhes">
              <i class="bi bi-eye"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Controles de Paginação -->
  <div class="d-flex justify-content-between align-items-center mt-3" *ngIf="totalPaginas > 1">
    <!-- Informações sobre registros -->
    <div class="text-muted">
      <small>
        Mostrando {{((paginaAtual - 1) * tamanhoPagina) + 1}} -
        {{Math.min(paginaAtual * tamanhoPagina, totalItens)}} de {{totalItens}} registros
      </small>
    </div>

    <!-- Controles de navegação -->
    <nav aria-label="Navegação de páginas">
      <ul class="pagination pagination-sm mb-0">
        <!-- Primeira página -->
        <li class="page-item" [class.disabled]="paginaAtual === 1">
          <button class="page-link" (click)="irParaPagina(1)" [disabled]="paginaAtual === 1">
            <i class="fas fa-angle-double-left"></i>
          </button>
        </li>

        <!-- Página anterior -->
        <li class="page-item" [class.disabled]="paginaAtual === 1">
          <button class="page-link" (click)="paginaAnterior()" [disabled]="paginaAtual === 1">
            <i class="fas fa-angle-left"></i>
          </button>
        </li>

        <!-- Páginas numeradas -->
        <li class="page-item" *ngFor="let pagina of obterPaginas()" [class.active]="pagina === paginaAtual">
          <button class="page-link" (click)="irParaPagina(pagina)">
            {{pagina}}
          </button>
        </li>

        <!-- Próxima página -->
        <li class="page-item" [class.disabled]="paginaAtual === totalPaginas">
          <button class="page-link" (click)="proximaPagina()" [disabled]="paginaAtual === totalPaginas">
            <i class="fas fa-angle-right"></i>
          </button>
        </li>

        <!-- Última página -->
        <li class="page-item" [class.disabled]="paginaAtual === totalPaginas">
          <button class="page-link" (click)="irParaPagina(totalPaginas)" [disabled]="paginaAtual === totalPaginas">
            <i class="fas fa-angle-double-right"></i>
          </button>
        </li>
      </ul>
    </nav>
  </div>
</div>

<!-- Spinner de carregamento -->
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="true">
  <p style="color: white"> Processando, por favor aguarde... </p>
</ngx-spinner>

<!-- Modal de detalhes do cadastro -->
<div class="modal fade show" tabindex="-1"
  [ngStyle]="{display: cadastroDetalhes ? 'flex' : 'none', background: 'rgba(0,0,0,0.4)', alignItems: 'center', justifyContent: 'center'}"
  *ngIf="cadastroDetalhes">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content" #conteudoModal>
      <div class="modal-header bg-gradient-info text-white">
        <h5 class="modal-title">
          <i class="bi bi-file-earmark-text me-2"></i>
          Detalhes do Cadastro
        </h5>
        <button type="button" class="btn-close" (click)="fecharModalDetalhes()"></button>
      </div>
      <div class="modal-body">
        <form class="form px-2 py-2">

          <!-- Cabeçalho com o número da vistoria (destaque) -->
          <div class="mb-3">
            <div class="p-3 rounded bg-gradient-info d-flex align-items-center">
              <i class="fas fa-search fs-4 me-3"></i>
              <div>
                <div class="small">Vistoria</div>
                <div class="h5 fw-bold mb-0">n° {{ formatNumeroOS(cadastroDetalhes) }}</div>
              </div>
            </div>
          </div>

          <fieldset>
            <legend class="mb-2">Dados do Consumidor</legend>
            <div class="grid-2 mb-2">
              <div>
                <label>Nome do Consumidor</label>
                <input type="text" [value]="cadastroDetalhes.nomeConsumidor || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>
                  <ng-container *ngIf="cadastroDetalhes.tipoUtilizacao === 'DOMICILIAR'; else cnpjLabel">
                    CPF
                  </ng-container>
                  <ng-template #cnpjLabel>CNPJ</ng-template>
                </label>
                <input type="text"
                  [value]="cadastroDetalhes.tipoUtilizacao === 'DOMICILIAR' ? maskCpf(cadastroDetalhes.cpf) : maskCnpj(cadastroDetalhes.cnpj)"
                  readonly class="campo-readonly" />
              </div>
            </div>

            <div class="grid-4 mb-2">
              <!-- <div *ngIf="cadastroDetalhes.matricula">
                <label>Matrícula</label>
                <input type="text" [value]="cadastroDetalhes.matricula || '-'" readonly class="campo-readonly" />
              </div> -->
              <div *ngIf="cadastroDetalhes.email">
                <label>Email</label>
                <input type="text" [value]="cadastroDetalhes.email || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Telefone</label>
                <input type="text" [value]="maskTelefone(cadastroDetalhes.telefone)" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Ciclo de Leitura</label>
                <input type="text" [value]="cadastroDetalhes.cicloDeLeitura || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Número Imóvel</label>
                <input type="text" [value]="cadastroDetalhes.numeroImovel || '-'" readonly class="campo-readonly" />
              </div>
            </div>

            <div class="grid-3 mb-2">
              <div>
                <label>Referência</label>
                <input type="text" [value]="cadastroDetalhes.referencia || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Data Cadastro</label>
                <input type="text" [value]="cadastroDetalhes.dataHoraInicio | date: 'dd/MM/yyyy HH:mm'" readonly
                  class="campo-readonly" />
              </div>
              <div>
                <label>Loja/Loc</label>
                <input type="text" [value]="cadastroDetalhes.lojLoc || '-'" readonly class="campo-readonly" />
              </div>
            </div>

            <div class="grid-3 mb-2">
              <div>
                <label>Sistema de Abastecimento</label>
                <input type="text" [value]="cadastroDetalhes.sistemaAbastecimento || '-'" readonly
                  class="campo-readonly" />
              </div>
              <div>
                <label>Tipo de Abastecimento</label>
                <input type="text" [value]="cadastroDetalhes.tipoAbastecimento || '-'" readonly
                  class="campo-readonly" />
              </div>
              <div>
                <label>Tipo Utilização</label>
                <input type="text" [value]="cadastroDetalhes.tipoUtilizacao || '-'" readonly class="campo-readonly" />
              </div>
            </div>
          </fieldset>

          <fieldset *ngIf="cadastroDetalhes.possuiDebito">
            <div>
              <label>Possui Débito</label>
              <input type="text" [value]="cadastroDetalhes.possuiDebito ? 'Sim' : 'Não'" readonly
                class="campo-readonly" />
            </div>
            <div class="grid-2 mb-2" *ngIf="cadastroDetalhes.valorDebito || cadastroDetalhes.dataInicioDebito">
              <div *ngIf="cadastroDetalhes.valorDebito">
                <label>Valor do Débito</label>
                <input type="text" [value]="cadastroDetalhes.valorDebito | currency:'BRL':'symbol':'1.2-2'" readonly
                  class="campo-readonly" />
              </div>
              <div *ngIf="cadastroDetalhes.dataInicioDebito">
                <label>Data Início Débito</label>
                <input type="text" [value]="cadastroDetalhes.dataInicioDebito | date:'dd/MM/yyyy'" readonly
                  class="campo-readonly" />
              </div>
            </div>
          </fieldset>

          <fieldset>
            <legend class="mb-2">Endereço</legend>
            <div class="grid-3 mb-2">
              <div>
                <label>CEP</label>
                <input type="text" [value]="cadastroDetalhes.endereco?.cep || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Logradouro</label>
                <input type="text" [value]="cadastroDetalhes.endereco?.logradouro || '-'" readonly
                  class="campo-readonly" />
              </div>
              <div>
                <label>Complemento</label>
                <input type="text" [value]="cadastroDetalhes.endereco?.complemento || '-'" readonly
                  class="campo-readonly" />
              </div>
              <div>
                <label>Bairro</label>
                <input type="text" [value]="cadastroDetalhes.endereco?.bairro || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Localidade</label>
                <input type="text" [value]="cadastroDetalhes.endereco?.cidade || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>UF</label>
                <input type="text" [value]="cadastroDetalhes.endereco?.estado || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Número</label>
                <input type="text" [value]="cadastroDetalhes.endereco?.numero || '-'" readonly class="campo-readonly" />
              </div>
            </div>
          </fieldset>

          <fieldset
            *ngIf="cadastroDetalhes.numeroHidrometro || cadastroDetalhes.marcacao || cadastroDetalhes.seloReloj || cadastroDetalhes.seloVirola || cadastroDetalhes.ramal || cadastroDetalhes.direto !== undefined || cadastroDetalhes.haCisterna !== undefined || cadastroDetalhes.haReservatorioElevado !== undefined || cadastroDetalhes.tipoEconomia || cadastroDetalhes.haPiscina !== undefined">
            <legend class="mb-2">ÁGUA</legend>
            <div class="grid-3 mb-2">
              <div>
                <label>Nº Hidrômetro</label>
                <input type="text" [value]="cadastroDetalhes.numeroHidrometro || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Marcação</label>
                <input type="text" [value]="cadastroDetalhes.marcacao || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Selo Reloj.</label>
                <input type="text" [value]="cadastroDetalhes.seloReloj || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Selo Virola</label>
                <input type="text" [value]="cadastroDetalhes.seloVirola || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Ramal</label>
                <input type="text" [value]="cadastroDetalhes.ramal || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Direto</label>
                <input type="text"
                  [value]="cadastroDetalhes.direto === undefined ? '-' : (cadastroDetalhes.direto ? 'Sim' : 'Não')"
                  readonly class="campo-readonly" />
              </div>
            </div>

            <div class="grid-1 mb-2">

              <fieldset *ngIf="cadastroDetalhes.haCisterna !== undefined">
                <h4>Cisterna</h4>
                <label>Há cisterna?</label>
                <input type="text" [value]="cadastroDetalhes.haCisterna ? 'Sim' : 'Não'" readonly
                  class="campo-readonly" />
                <div *ngIf="cadastroDetalhes.haCisterna && cadastroDetalhes.capacidadeCisternaInformada">
                  <label>Capacidade Informada</label>
                  <input type="text" [value]="cadastroDetalhes.capacidadeCisternaInformada" readonly
                    class="campo-readonly" />
                </div>
                <div *ngIf="cadastroDetalhes.haCisterna && cadastroDetalhes.observacoesCisterna">
                  <label>Observações</label>
                  <textarea readonly class="campo-readonly"
                    rows="2">{{ cadastroDetalhes.observacoesCisterna }}</textarea>
                </div>
              </fieldset>

              <fieldset *ngIf="cadastroDetalhes.haReservatorioElevado !== undefined">
                <h4>Reservatório Elevado</h4>
                <label>Há Reservatórios Elevados?</label>
                <input type="text" [value]="cadastroDetalhes.haReservatorioElevado ? 'Sim' : 'Não'" readonly
                  class="campo-readonly" />
                <div
                  *ngIf="cadastroDetalhes.haReservatorioElevado && cadastroDetalhes.capacidadeReservatorioElevadoInformada">
                  <label>Capacidade Informada</label>
                  <input type="text" [value]="cadastroDetalhes.capacidadeReservatorioElevadoInformada" readonly
                    class="campo-readonly" />
                </div>
                <div *ngIf="cadastroDetalhes.haReservatorioElevado && cadastroDetalhes.observacoesReservatorioElevado">
                  <label>Observações</label>
                  <textarea readonly class="campo-readonly"
                    rows="2">{{ cadastroDetalhes.observacoesReservatorioElevado }}</textarea>
                </div>
              </fieldset>

              <fieldset *ngIf="cadastroDetalhes.haPiscina !== undefined">
                <h4>Piscina</h4>
                <label>Existe Piscina?</label>
                <input type="text" [value]="cadastroDetalhes.haPiscina ? 'Sim' : 'Não'" readonly
                  class="campo-readonly" />
                <div *ngIf="cadastroDetalhes.haPiscina && cadastroDetalhes.dimensoesPiscina">
                  <label>Dimensões:</label>
                  <input type="text" [value]="cadastroDetalhes.dimensoesPiscina" readonly class="campo-readonly" />
                </div>
              </fieldset>
            </div>
          </fieldset>


          <fieldset *ngIf="cadastroDetalhes.tipoEconomia">
            <legend class="mb-2">Economias</legend>
            <div class="grid-3 mb-2">
              <div>
                <label>Tipos de Economias</label>
                <input type="text" [value]="cadastroDetalhes.tipoEconomia || '-'" readonly class="campo-readonly" />
              </div>
              <div *ngIf="cadastroDetalhes.dUnica">
                <label>Sub Categoria</label>
                <input type="text" [value]="cadastroDetalhes.dUnica" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Número de Economias</label>
                <input type="text" [value]="cadastroDetalhes.numeroDeEconomias || '-'" readonly
                  class="campo-readonly" />
              </div>
            </div>

            <!-- Domiciliar -->
            <div class="grid-4 mb-2" *ngIf="cadastroDetalhes.tipoEconomia === 'DOMICILIAR'">
              <div *ngIf="cadastroDetalhes.numeroDeQuartos">
                <label>Nº Quartos</label>
                <input type="text" [value]="cadastroDetalhes.numeroDeQuartos" readonly class="campo-readonly" />
              </div>
              <div *ngIf="cadastroDetalhes.numeroDeSalas">
                <label>Nº Salas</label>
                <input type="text" [value]="cadastroDetalhes.numeroDeSalas" readonly class="campo-readonly" />
              </div>
              <div *ngIf="cadastroDetalhes.numeroWcPav">
                <label>Nº WC/PAV</label>
                <input type="text" [value]="cadastroDetalhes.numeroWcPav" readonly class="campo-readonly" />
              </div>
              <div *ngIf="cadastroDetalhes.numeroDeBoxes">
                <label>Nº Boxes</label>
                <input type="text" [value]="cadastroDetalhes.numeroDeBoxes" readonly class="campo-readonly" />
              </div>
            </div>

           <!-- COMERCIO -->
              <div class="grid-3 mb-2"
                *ngIf="cadastroDetalhes.tipoEconomia === 'COMERCIO'">
                <div>
                  <label>Nº Salas/Lojas/Quartos</label>
                  <input type="text" [value]="cadastroDetalhes.numeroDeQuartos" readonly class="campo-readonly" />
                </div>
                <div>
                  <label>Tipo Comércio</label>
                  <input type="text" [value]="cadastroDetalhes.tipoComercio" readonly class="campo-readonly" />
                </div>
                <div>
                  <label>Alunos</label>
                  <input type="text" [value]="cadastroDetalhes.numeroDeAlunos" readonly class="campo-readonly" />
                </div>
                <div>
                  <label>Nº Boxes</label>
                  <input type="text" [value]="cadastroDetalhes.numeroDeBoxes" readonly class="campo-readonly" />
                </div>
                <div>
                  <label>Nº Banheiro</label>
                  <input type="text" [value]="cadastroDetalhes.banheiros" readonly class="campo-readonly" />
                </div>
                <div>
                  <label>Área (m²)</label>
                  <input type="text" [value]="cadastroDetalhes.areaMetroQuadrado" readonly class="campo-readonly" />
                </div>
              </div>

          <!-- Indústria -->
            <div class="grid-3 mb-2"
              *ngIf="cadastroDetalhes.tipoEconomia === 'INDUSTRIA'">
              <div>
                <label>Tipo Indústria</label>
                <input type="text" [value]="cadastroDetalhes.tipoIndustria" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Área (m²)</label>
                <input type="text" [value]="cadastroDetalhes.areaMetroQuadrado" readonly class="campo-readonly" />
              </div>
            </div>
          </fieldset>

          <fieldset
            *ngIf="cadastroDetalhes.haColetor !== undefined || cadastroDetalhes.coletor || cadastroDetalhes.gap || cadastroDetalhes.rio || cadastroDetalhes.valao || cadastroDetalhes.focaFiltro || cadastroDetalhes.vala || cadastroDetalhes.sumidouro || cadastroDetalhes.tipoValaValao">
            <legend class="mb-2">ESGOTO</legend>
            <div *ngIf="cadastroDetalhes.haColetor !== undefined">
              <label>Tem coletor?</label>
              <input type="text" [value]="cadastroDetalhes.haColetor ? 'Sim' : 'Não'" readonly class="campo-readonly" />
            </div>

            <div
              *ngIf="cadastroDetalhes.haColetor && (cadastroDetalhes.coletor || cadastroDetalhes.gap || cadastroDetalhes.rio || cadastroDetalhes.valao || cadastroDetalhes.focaFiltro || cadastroDetalhes.vala || cadastroDetalhes.sumidouro)">
              <label>Efluente encaminhado para:</label>
              <div class="grid-4 mb-2">
                <div *ngIf="isAffirmative(cadastroDetalhes.coletor)">
                  <label>Coletor</label>
                  <input type="text" value="Sim" readonly class="campo-readonly" />
                </div>
                <div *ngIf="isAffirmative(cadastroDetalhes.gap)">
                  <label>GAP</label>
                  <input type="text" value="Sim" readonly class="campo-readonly" />
                </div>
                <div *ngIf="isAffirmative(cadastroDetalhes.rio)">
                  <label>RIO</label>
                  <input type="text" value="Sim" readonly class="campo-readonly" />
                </div>
                <div *ngIf="isAffirmative(cadastroDetalhes.valao)">
                  <label>VALÃO</label>
                  <input type="text" value="Sim" readonly class="campo-readonly" />
                </div>
                <div *ngIf="isAffirmative(cadastroDetalhes.focaFiltro)">
                  <label>Fossa/Filtro</label>
                  <input type="text" value="Sim" readonly class="campo-readonly" />
                </div>
                <div *ngIf="isAffirmative(cadastroDetalhes.vala)">
                  <label>Vala</label>
                  <input type="text" value="Sim" readonly class="campo-readonly" />
                </div>
                <div *ngIf="isAffirmative(cadastroDetalhes.sumidouro)">
                  <label>Sumidouro</label>
                  <input type="text" value="Sim" readonly class="campo-readonly" />
                </div>
              </div>
              <div *ngIf="cadastroDetalhes.tipoValaValao">
                <label>A vala ou valão é de:</label>
                <input type="text" [value]="cadastroDetalhes.tipoValaValao" readonly class="campo-readonly" />
              </div>
            </div>
          </fieldset>

          <fieldset>
            <legend class="mb-2">FOTOS DO LOCAL</legend>
            <div class="fotos-grid mb-2">
              <div class="foto-item" *ngFor="let foto of cadastroDetalhes.fotos">
                <div class="foto-wrapper">
                  <img [src]="getFullImageUrl(foto.url)" alt="Foto do Local" class="foto-local"
                    (click)="abrirModalFoto(foto.url)"
                    [ngStyle]="{'transform': 'rotate(' + getPhotoRotation(foto.url) + 'deg)'}" />
                </div>
                <div class="foto-actions mt-2" style="display:flex;gap:8px;justify-content:center;">
                  <a *ngIf="foto?.latitude && foto?.longitude"
                    [href]="'https://www.google.com/maps?q=' + foto.latitude + ',' + foto.longitude" target="_blank"
                    class="btn btn-outline-success btn-sm">
                    <i class="bi bi-geo-alt-fill"></i> Mapa
                  </a>

                  <div class="rotate-buttons">
                    <button type="button" class="btn btn-light btn-sm rotate-btn" (click)="rotatePhoto(foto.url, -90)"
                      title="Girar esquerda">
                      <i class="bi bi-arrow-counterclockwise"></i>
                    </button>
                    <button type="button" class="btn btn-light btn-sm rotate-btn" (click)="rotatePhoto(foto.url, 90)"
                      title="Girar direita">
                      <i class="bi bi-arrow-clockwise"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="!cadastroDetalhes.fotos?.length" class="alert alert-warning">
              Nenhuma foto disponível.
            </div>
          </fieldset>

          <fieldset *ngIf="cadastroDetalhes.outrasInformacoes">
            <legend class="mb-2">OUTRAS INFORMAÇÕES</legend>
            <div>
              <label>Descrição da Conclusão</label>
              <textarea readonly class="campo-readonly" rows="6">{{ cadastroDetalhes.outrasInformacoes }}</textarea>
            </div>
          </fieldset>

          <fieldset class="fotos">
            <legend class="mb-2">FOTOS DE DOCUMENTOS</legend>
            <div class="fotos-grid mb-2">
              <div class="foto-item" *ngFor="let fotoDoc of cadastroDetalhes.fotosDocumento">
                <div class="foto-wrapper">
                  <img [src]="getFullImageUrl(fotoDoc.url)" alt="Foto do Documento" class="foto-local"
                    (click)="abrirModalFoto(fotoDoc.url)"
                    [ngStyle]="{'transform': 'rotate(' + getPhotoRotation(fotoDoc.url) + 'deg)'}" />
                </div>
                <div class="foto-actions mt-2" style="display:flex;gap:8px;justify-content:center;">
                  <a *ngIf="fotoDoc?.latitude && fotoDoc?.longitude"
                    [href]="'https://www.google.com/maps?q=' + fotoDoc.latitude + ',' + fotoDoc.longitude"
                    target="_blank" class="btn btn-outline-success btn-sm">
                    <i class="bi bi-geo-alt-fill"></i> Mapa
                  </a>

                  <div class="rotate-buttons">
                    <button type="button" class="btn btn-light btn-sm rotate-btn"
                      (click)="rotatePhoto(fotoDoc.url, -90)" title="Girar esquerda">
                      <i class="bi bi-arrow-counterclockwise"></i>
                    </button>
                    <button type="button" class="btn btn-light btn-sm rotate-btn" (click)="rotatePhoto(fotoDoc.url, 90)"
                      title="Girar direita">
                      <i class="bi bi-arrow-clockwise"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="!cadastroDetalhes.fotosDocumento?.length" class="alert alert-warning">
              Nenhuma foto disponível.
            </div>
          </fieldset>

          <fieldset>
            <legend class="mb-2">Localização</legend>
            <div class="grid-2 mb-2">
              <div>
                <label>Início</label>
                <div *ngIf="cadastroDetalhes.latitudeInicio && cadastroDetalhes.longitudeInicio"
                  class="coordenadas-label">
                  <span class="badge bg-light text-dark">Lat: {{ cadastroDetalhes.latitudeInicio }} | Lng: {{
                    cadastroDetalhes.longitudeInicio }}</span>
                </div>
                <a *ngIf="cadastroDetalhes.latitudeInicio && cadastroDetalhes.longitudeInicio"
                  [href]="'https://www.google.com/maps?q=' + cadastroDetalhes.latitudeInicio + ',' + cadastroDetalhes.longitudeInicio"
                  target="_blank" class="btn btn-outline-success btn-sm ms-1">
                  <i class="bi bi-geo-alt-fill"></i> Ver no mapa
                </a>
                <span *ngIf="!cadastroDetalhes.latitudeInicio || !cadastroDetalhes.longitudeInicio"
                  class="text-muted">Sem localização</span>
                <div class="mt-2" *ngIf="cadastroDetalhes.dataHoraInicio">
                  <label>Data/Hora Início</label>
                  <input type="text" [value]="cadastroDetalhes.dataHoraInicio | date:'dd/MM/yyyy HH:mm:ss'" readonly
                    class="campo-readonly" />
                </div>
              </div>
              <div>
                <label>Fim</label>
                <div *ngIf="cadastroDetalhes.latitudeFim && cadastroDetalhes.longitudeFim" class="coordenadas-label">
                  <span class="badge bg-light text-dark">Lat: {{ cadastroDetalhes.latitudeFim }} | Lng: {{
                    cadastroDetalhes.longitudeFim }}</span>
                </div>
                <a *ngIf="cadastroDetalhes.latitudeFim && cadastroDetalhes.longitudeFim"
                  [href]="'https://www.google.com/maps?q=' + cadastroDetalhes.latitudeFim + ',' + cadastroDetalhes.longitudeFim"
                  target="_blank" class="btn btn-outline-danger btn-sm ms-1">
                  <i class="bi bi-geo-alt-fill"></i> Ver no mapa
                </a>
                <span *ngIf="!cadastroDetalhes.latitudeFim || !cadastroDetalhes.longitudeFim" class="text-muted">Sem
                  localização</span>
                <div class="mt-2" *ngIf="cadastroDetalhes.dataHoraFim">
                  <label>Data/Hora Fim</label>
                  <input type="text" [value]="cadastroDetalhes.dataHoraFim | date:'dd/MM/yyyy HH:mm:ss'" readonly
                    class="campo-readonly" />
                </div>
              </div>
            </div>
            <div class="map-container">
              <div id="map-cadastro"></div>
            </div>
          </fieldset>

          <fieldset>
            <legend class="mb-2">Dados do Acompanhante</legend>
            <div class="grid-3 mb-2">
              <div>
                <label>Nome do Acompanhante</label>
                <input type="text" [value]="cadastroDetalhes.nomeAcompanhante || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>CPF do Acompanhante</label>
                <input type="text" [value]="maskCpf(cadastroDetalhes.cpfAcompanhante)" readonly
                  class="campo-readonly" />
              </div>
              <div>
                <label>Telefone do Acompanhante</label>
                <input type="text" [value]="maskTelefone(cadastroDetalhes.telefoneAcompanhante)" readonly
                  class="campo-readonly" />
              </div>
            </div>
            <div>
              <label>Assinatura do Acompanhante:</label>
              <div class="signature-container">
                <img *ngIf="cadastroDetalhes.assinaturaAcompanhante?.url || cadastroDetalhes.assinaturaAcompanhante"
                  [src]="getFullImageUrl(cadastroDetalhes.assinaturaAcompanhante?.url || cadastroDetalhes.assinaturaAcompanhante)"
                  alt="Assinatura do Acompanhante" class="signature-image"
                  (click)="abrirModalFoto(cadastroDetalhes.assinaturaAcompanhante?.url || cadastroDetalhes.assinaturaAcompanhante)">
                <div *ngIf="!cadastroDetalhes.assinaturaAcompanhante?.url && !cadastroDetalhes.assinaturaAcompanhante"
                  class="sem-dados-campo">
                  Não informado
                </div>
              </div>
            </div>
          </fieldset>

          <fieldset>
            <legend class="mb-2">Dados do Vistoriador</legend>
            <div class="grid-2 mb-2">
              <div>
                <label>Nome do Vistoriador</label>
                <input type="text" [value]="cadastroDetalhes.nomeVistoriante || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Data da Vistoria</label>
                <input type="text" [value]="cadastroDetalhes.dataHoraInicio | date:'dd/MM/yyyy HH:mm'" readonly
                  class="campo-readonly" />
              </div>
            </div>
            <div class="grid-1 vistoriador-foto mb-2">
              <div
                *ngIf="cadastroDetalhes.fotoVistoriante && cadastroDetalhes.fotoVistoriante !== 'URL_PADRAO_SEM_IMAGEM'">
                <label>Foto do Vistoriador</label>
                <div class="foto-vistoriador" (click)="abrirModalFoto(cadastroDetalhes.fotoVistoriante)">
                  <img [src]="getFullImageUrl(cadastroDetalhes.fotoVistoriante)" alt="Foto do Vistoriador"
                    class="foto-vistoriador">
                </div>
              </div>
              <div
                *ngIf="!cadastroDetalhes.fotoVistoriante || cadastroDetalhes.fotoVistoriante === 'URL_PADRAO_SEM_IMAGEM'"
                class="alert alert-warning">
                Foto não disponível
              </div>
            </div>
            <div>
              <label>Assinatura do Vistoriador:</label>
              <div class="signature-container">
                <img *ngIf="cadastroDetalhes.assinaturaVistoriador || cadastroDetalhes.assinaturaVistoriante?.url"
                  [src]="getFullImageUrl(cadastroDetalhes.assinaturaVistoriador || cadastroDetalhes.assinaturaVistoriante?.url)"
                  alt="Assinatura do Vistoriador" class="signature-image"
                  (click)="abrirModalFoto(cadastroDetalhes.assinaturaVistoriador || cadastroDetalhes.assinaturaVistoriante?.url)">
                <div *ngIf="!cadastroDetalhes.assinaturaVistoriador && !cadastroDetalhes.assinaturaVistoriante?.url"
                  class="sem-dados-campo">
                  Não informado
                </div>
              </div>
            </div>
          </fieldset>
          <div *ngIf="cadastroDetalhes?.analisadoPorNome && cadastroDetalhes?.status === 'Validado'"
            class="d-flex justify-content-end mt-4">
            <span class="badge bg-gradient-info"
              style="font-size: 1.1rem; padding: 12px 28px; border-radius: 18px; box-shadow: 0 2px 8px rgba(0,0,0,0.08); letter-spacing: 1px; font-weight: 700; display: flex; flex-direction: column; align-items: flex-start;">
              <span><i class="bi bi-person-check-fill me-2"></i> Analisado por: {{ cadastroDetalhes.analisadoPorNome
                }}</span>
              <span *ngIf="cadastroDetalhes.dataHoraInicioAnalise"
                style="font-size: 0.95rem; font-weight: 500; margin-top: 2px;">
                <i class="bi bi-calendar-check me-1"></i>
                Data da análise: {{ cadastroDetalhes.dataHoraInicioAnalise | date: 'dd/MM/yyyy HH:mm' }}
              </span>
            </span>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger me-2" (click)="exportarCadastroParaPDF()">
          <i class="bi bi-file-earmark-pdf-fill me-1"></i> Exportar PDF
        </button>
        <button type="button" class="btn btn-secondary" (click)="fecharModalDetalhes()">Fechar</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal de visualização de foto ampliada -->
<div class="modal-foto" [class.show]="mostrarModalFoto" *ngIf="mostrarModalFoto" (click)="fecharModalFoto()">
  <div class="modal-foto-content" (click)="$event.stopPropagation()">
    <button type="button" class="btn-close-foto" (click)="fecharModalFoto()">
      <i class="fas fa-times"></i>
    </button>
    <img [src]="getFullImageUrl(fotoSelecionada)" alt="Foto Ampliada" class="foto-ampliada">
  </div>
</div>

<!-- Container oculto para exportação completa -->
<div #conteudoCompleto style="position: absolute; top: -9999px; left: -9999px; width: 1000px;">
  <div [innerHTML]="htmlCompletoParaExportar"></div>
</div>